<template>
  <div class="container">
    <md-card class="dash-content">
      <div class="header-wrapper">
        <PageHeader :title="id ? 'Update Advert' : 'Add New Advert'" />
        <div>
          <md-button :to="{ name: 'Adverts' }" class="md-primary">
            Back
          </md-button>
        </div>
      </div>

      <div>
        <form novalidate @submit.prevent="validateUser">
          <div class="">
            <section class="row my-3" style="width: 100%">
              <div class="col-md-8">
                <div class="s-title">
                  <strong>Ads Details</strong>
                </div>
                <md-field :class="getValidationClass('title')">
                  <label>Title</label>
                  <md-input v-model="form.title" required></md-input>
                  <span class="md-error" v-if="!$v.form.title.required"
                    >Section title is required</span
                  >
                </md-field>

                <md-field
                  v-if="metadata"
                  :class="getValidationClass('section_id')"
                >
                  <label for="category">Advert Category</label>
                  <md-select
                    v-model="form.section_id"
                    name="category"
                    id="category"
                  >
                    <md-option value="" disabled>Select Section</md-option>
                    <md-option
                      v-for="(section, id) in metadata.sections"
                      :key="id"
                      :value="id"
                      >{{ section }}</md-option
                    >
                  </md-select>
                  <span class="md-error" v-if="!$v.form.section_id.required"
                    >Category is required</span
                  >
                </md-field>

                <div class="users-search">
                  <md-field>
                    <label>Advert User</label>
                    <md-input
                      v-model="search"
                      placeholder="Search for user"
                      type="text"
                      clearable
                      @focus="isOpen = true"
                    ></md-input>
                  </md-field>
                  <span v-if="getting">loading...</span>

                  <div class="users-card" v-if="users.mdData.length && isOpen">
                    <div
                      @click="setUser(user)"
                      class="items"
                      v-for="user in users.mdData"
                      :key="user.id + 'user'"
                    >
                      {{ user.first_name }} {{ user.last_name }}
                    </div>
                  </div>
                  <div v-if="user" class="selected">
                    {{ user.first_name }} {{ user.last_name }}
                  </div>
                </div>
                <md-field :class="getValidationClass('link')">
                  <label>Advert Link</label>
                  <md-input v-model="form.link" type="url" required></md-input>
                  <span class="md-error" v-if="!$v.form.link.required"
                    >Section link is required</span
                  >
                </md-field>

                <md-field :class="getValidationClass('amount')">
                  <label>Amount</label>
                  <md-input
                    v-model="form.amount"
                    type="number"
                    required
                  ></md-input>
                  <span class="md-error" v-if="!$v.form.amount.required"
                    >Section amount is required</span
                  >
                </md-field>
                <div class="field">
                  <label>Publish</label>
                  <select
                    v-model="form.status"
                    class="form-control border"
                    name="status"
                  >
                    <option value="live">Live</option>
                    <option value="draft">Draft</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2" style="flex: 1">
                <section>
                  <div class="s-title">
                    <strong>Ads Details</strong>
                  </div>

                  <md-field :class="getValidationClass('start_date')">
                    <label style="top: 0px">Start Date</label>
                    <md-input
                      v-model="form.start_date"
                      type="date"
                      required
                      focusable
                    ></md-input>
                    <span class="md-error" v-if="!$v.form.start_date.required"
                      >Start date is required</span
                    >
                  </md-field>

                  <md-field :class="getValidationClass('end_date')">
                    <label style="top: 0px">End Date</label>
                    <md-input
                      v-model="form.end_date"
                      type="date"
                      required
                    ></md-input>
                    <span class="md-error" v-if="!$v.form.end_date.required"
                      >End date is required</span
                    >
                  </md-field>
                </section>

                <section>
                  <div class="s-title">
                    <strong>Image</strong>
                  </div>

                  <div v-if="id" style="height: 130px; margin: 10px 0px">
                    <img
                      :src="preview"
                      alt="Preview"
                      width="100%"
                      height="100%"
                      style="object-fit: contain; height: 100% !important"
                    />
                  </div>
                  <label for="media" class="image-box">
                    <div class="preview" v-if="url">
                      <img :src="url" />
                    </div>
                    <div v-else>
                      <svg
                        width="39"
                        height="32"
                        viewBox="0 0 69 62"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M36.8973 29.1038C36.2664 28.4854 35.4182 28.139 34.5348 28.139C33.6514 28.139 32.8032 28.4854 32.1723 29.1038L22.0473 38.8913C21.6892 39.1868 21.3959 39.553 21.1857 39.9671C20.9756 40.3811 20.8532 40.834 20.8261 41.2975C20.799 41.761 20.8678 42.2252 21.0283 42.6609C21.1887 43.0965 21.4373 43.4944 21.7586 43.8297C22.0799 44.1649 22.4668 44.4302 22.8953 44.6091C23.3238 44.7879 23.7845 44.8764 24.2488 44.8691C24.713 44.8617 25.1707 44.7586 25.5933 44.5663C26.0159 44.374 26.3943 44.0965 26.7048 43.7513L31.126 39.4651V58.5001C31.126 59.3952 31.4816 60.2536 32.1145 60.8865C32.7475 61.5195 33.6059 61.8751 34.501 61.8751C35.3961 61.8751 36.2546 61.5195 36.8875 60.8865C37.5204 60.2536 37.876 59.3952 37.876 58.5001V39.6338L42.2298 44.0213C42.5435 44.3376 42.9168 44.5887 43.3281 44.7601C43.7393 44.9314 44.1805 45.0196 44.626 45.0196C45.0716 45.0196 45.5127 44.9314 45.924 44.7601C46.3352 44.5887 46.7085 44.3376 47.0223 44.0213C47.3386 43.7076 47.5897 43.3343 47.761 42.923C47.9324 42.5117 48.0206 42.0706 48.0206 41.6251C48.0206 41.1795 47.9324 40.7384 47.761 40.3271C47.5897 39.9158 47.3386 39.5426 47.0223 39.2288L36.8973 29.1038Z"
                          fill="#808080"
                        />
                        <path
                          d="M53.6378 14.625C52.2607 10.6461 49.6775 7.19533 46.2477 4.75299C42.8179 2.31065 38.7121 0.998169 34.5015 0.998169C30.291 0.998169 26.1852 2.31065 22.7554 4.75299C19.3256 7.19533 16.7424 10.6461 15.3653 14.625C12.333 15.0311 9.46821 16.2539 7.0773 18.1626C4.68639 20.0713 2.85934 22.5941 1.7916 25.4611C0.723854 28.328 0.455584 31.4313 1.01549 34.439C1.57539 37.4467 2.9424 40.2456 4.97029 42.5363C5.21524 42.9677 5.55232 43.3399 5.9575 43.6262C6.36269 43.9126 6.82603 44.106 7.31452 44.1929C7.80302 44.2797 8.30465 44.2578 8.78371 44.1287C9.26276 43.9995 9.70745 43.7664 10.0861 43.4458C10.4648 43.1252 10.7681 42.725 10.9745 42.2738C11.1808 41.8226 11.2852 41.3315 11.2801 40.8354C11.275 40.3392 11.1606 39.8503 10.945 39.4035C10.7294 38.9566 10.418 38.5628 10.0328 38.25C8.72705 36.7902 7.87274 34.983 7.57339 33.0474C7.27403 31.1119 7.54248 29.131 8.34622 27.3449C9.14995 25.5589 10.4545 24.0443 12.1016 22.9846C13.7488 21.925 15.668 21.3659 17.6265 21.375H17.964C18.7536 21.3909 19.5238 21.1295 20.1404 20.6361C20.7571 20.1428 21.1813 19.4488 21.339 18.675C21.9587 15.6232 23.6144 12.8795 26.0255 10.9088C28.4367 8.93804 31.455 7.86146 34.569 7.86146C37.6831 7.86146 40.7014 8.93804 43.1125 10.9088C45.5237 12.8795 47.1793 15.6232 47.799 18.675C47.9568 19.4488 48.381 20.1428 48.9977 20.6361C49.6143 21.1295 50.3845 21.3909 51.174 21.375H51.3765C53.3351 21.3659 55.2543 21.925 56.9014 22.9846C58.5486 24.0443 59.8531 25.5589 60.6569 27.3449C61.4606 29.131 61.729 31.1119 61.4297 33.0474C61.1303 34.983 60.276 36.7902 58.9703 38.25C58.673 38.5834 58.4448 38.9725 58.2991 39.3947C58.1533 39.8169 58.0927 40.2639 58.121 40.7097C58.1493 41.1555 58.2657 41.5912 58.4636 41.9917C58.6616 42.3921 58.937 42.7493 59.274 43.0425C59.8893 43.5851 60.6812 43.8851 61.5015 43.8862C61.9807 43.8856 62.4543 43.783 62.8908 43.5851C63.3272 43.3873 63.7165 43.0988 64.0328 42.7388C66.1169 40.452 67.5323 37.6363 68.1241 34.5994C68.7159 31.5625 68.4613 28.4214 67.3883 25.5194C66.3153 22.6174 64.4651 20.0663 62.04 18.1449C59.6149 16.2235 56.7083 15.0058 53.6378 14.625Z"
                          fill="#808080"
                        />
                      </svg>

                      <br /><br />
                      <span>{{
                        filename || "Click here to choose your image"
                      }}</span>
                    </div>
                  </label>
                  <input
                    id="media"
                    type="file"
                    @change="handleFiles"
                    name="media"
                    style="display: none"
                  />
                </section>
              </div>
            </section>
          </div>
          <mdc-button :loading="loading">{{
            id ? "Update Advert" : "Create Advert"
          }}</mdc-button>
        </form>
      </div>
    </md-card>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("advert");
import moment from "moment";

export default {
  mixins: [validationMixin],
  data: () => ({
    form: {
      start_date: ""
    },
    loading: false,
    search: "",
    metadata: null,
    user: null,
    isOpen: false,
    fetching: true,
    time: null,
    filename: "",
    url: "",
    preview: ""
  }),
  validations: {
    form: {
      title: {
        required
      },
      link: {
        required
      },
      amount: {
        required
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      section_id: {
        required
      }
    }
  },
  watch: {
    "form.section_id"(val) {
      let selected = this.metadata.sections_data.find(
        (section) => section.id == val
      );

      this.form.amount = selected.amount;
    },
    search(val) {
      this.waitForIt(val);
    }
  },
  methods: {
    ...mapActions(["createAdvert", "updateAdvert", "getMetaData", "getAdvert"]),
    async validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = { ...this.form };

        if (!this.user) return this.toast("error", "Opps, please select owner");

        data.owner_id = this.user.id;

        try {
          this.loading = true;
          let call = this.id
            ? this.updateAdvert(data)
            : this.createAdvert(data);
          let msg = this.id ? "Advert Updated" : "Advert Created";
          await call;
          this.toast("success", msg);
          this.$router.push({ name: "Adverts" });
          this.loading = false;
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.toast("error", "Opps, Something went wrong ");
        }
      }
    },
    setUser(user) {
      this.isOpen = false;
      this.user = user;
    },
    async getData() {
      this.fetching = true;
      const res = await this.getMetaData();
      console.log(res);
      this.fetching = false;
      this.metadata = res;
    },
    handleFiles(e) {
      let file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.form.media = file;
      this.filename = file.name;
    },
    async submitSearch() {
      await this.$store.dispatch("user/getUsers", { keyword: this.search });
    },
    waitForIt(val) {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => this.submitSearch(val), 1000);
    },
    async getAdvertData() {
      if (this.id) {
        this.fetching = true;
        const data = await this.getAdvert(this.id);
        this.form = {
          id: data.id,
          title: data.title,
          status: data.status,
          amount: data.amount,
          section_id: data.section_id,
          link: data.link,
          start_date: data.start_date,
          end_date: data.end_date
        };
        this.preview = data.preview;
        this.user = data.owner;
        this.fetching = false;
      }
    }
  },
  mounted() {
    this.getData();
    this.getAdvertData();
  },
  computed: {
    users() {
      return this.$store.getters["user/users"];
    },
    getting() {
      return this.$store.getters["user/loading"];
    },
    id() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped lang="scss">
.feature-attributes {
  width: 100%;
  .wrapper {
    display: flex;
    align-items: center;
    gap: 20px;

    .val {
      flex: 1;
    }

    .attr {
      width: 25%;
    }
  }
}

.s-title {
  margin-bottom: 20px;
  strong {
    font-weight: 700;
  }
}

.image-box {
  height: 130px;
  width: 100%;
  border: 2px dashed #d2d2d2;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 200px;
  }

  .preview {
    height: 100%;
    width: 100%;
    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
}

.users-search {
  position: relative;

  .users-card {
    width: 100%;
    background: #fff;
    max-height: 300px;
    overflow-y: auto;

    .items {
      padding: 10px;
      cursor: pointer;

      &:hover {
        background: #f9f9f9;
      }
    }
  }
  .selected {
    padding: 15px 10px;
    background: #e3ffe6;
    border-radius: 5px;
    font-weight: 700;
  }
}
</style>
